import { Pipe, PipeTransform } from '@angular/core';

export const isWhite = (colour: string | undefined): boolean => {
  if (!colour) {
    return false;
  }

  const normalizedColour = colour.toLowerCase();
  const whiteColours = ['#ffffff', '#fff', 'white'];

  return whiteColours.includes(normalizedColour);
};

@Pipe({
  name: 'isWhite',
})
export class IsWhitePipe implements PipeTransform {
  public transform(value: string | undefined): boolean {
    return isWhite(value);
  }
}
